"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const convertOversToBallsTotal_1 = __importDefault(require("./convertOversToBallsTotal"));
const getBallsRemaining = (props) => {
    const bpo = props.ballsPerOver || undefined;
    const oB = convertOversToBallsTotal_1.default({
        overs: props.oversBowled,
        ballsPerOver: bpo,
    });
    const oT = convertOversToBallsTotal_1.default({
        overs: props.oversTarget || props.oversPerInnings,
        ballsPerOver: bpo,
    });
    return oT - oB;
};
exports.default = getBallsRemaining;
//# sourceMappingURL=getBallsRemaining.js.map